import { useSelector } from "react-redux";
import { AppState } from "../store";

export const useAppSelector = <T = unknown>(
  selector: (state: AppState) => T,
  equalityFn?: (left: T, right: T) => boolean
) => useSelector(selector, equalityFn);
